<div class="ui-g form-group" style="margin-bottom: 5px; width: 800px;"
    *ngIf="response.success!=null && response.success==true">

    <div class="card">

        <p-table #dt styleClass="ui-table-cars" id="doctors-grid" expandableRows="true" [responsive]="true">
            <ng-template pTemplate="caption" style="color: aliceblue;">
                <tr>
                    <td style="text-align: justify;">
                        <img [src]="profile.data.avatar_url==null || (profile.data.avatar_url!=null && profile.data.avatar_url.length==0)
                        ?'./assets/images/default_profile.jpg':profile.data.avatar_url"
                             height="120px" alt="Dr. Photo">
                        <h4>{{profile.data.first_name}}
                            {{profile.data.last_name}}
                        </h4>

                        <h4>{{profile.data.other_medical_profile.primary_occupation}}, {{profile.data.state_name}},
                            {{profile.data.country.country_name}}</h4>


            </ng-template>

            <ng-template pTemplate="header" let-columns>

                <tr style="text-align: left;" *ngIf="this.profile.data.other_medical_profile.secondary_occupation?.length>0">
                    <p ><span class="header-section" style="margin-right: 2%;">Secondary Occupation :</span>  {{this.profile.data.other_medical_profile.secondary_occupation}} </p>
                    
                    <!-- <ul>
                        <li style="white-space: pre-line;">
                            {{this.profile.data.other_medical_profile.secondary_occupation}}
                        </li>
                    </ul> -->
                </tr>

                <tr style="text-align: left;" *ngIf="profile.languages.length>0">
                    <p class="header-section">Languages Spoken</p>
                    <ul>
                        <li style="white-space: pre-line;" *ngFor="let l of this.profile.languages">
                            {{l.language_name +" ("+l.english_name+")"}}
                        </li>
                    </ul>
                </tr>

                <!-- <tr style="text-align: justify;" *ngIf="profile.description?.length>0">
                    <h4 class="display-4">Bio</h4> {{profile.description}}
                </tr> -->

                <tr style="text-align: justify;" *ngIf="this.profile.data.other_medical_profile.education?.length>0">
                    <h4 class="display-4">School/College </h4>
                    <ul>
                        <li *ngFor="let edu of this.profile.data.other_medical_profile.education">{{edu.name}} :
                            {{edu.year}} </li>
                    </ul>
                </tr>

                <tr style="text-align: left;" *ngIf="this.profile.data.other_medical_profile.certifications?.length>0">
                    <h4 class="display-4">Certifications</h4>
                    <ul>
                        <li *ngFor="let board of this.profile.data.other_medical_profile.certifications">{{board}}</li>
                    </ul>
                </tr>
                <tr style="text-align: left;"
                    *ngIf="this.profile.data.other_medical_profile.affiliated_hospitals?.length>0">
                    <h4 class="display-4">Affiliated Hospitals</h4>
                    <ul>
                        <li *ngFor="let hospital of this.profile.data.other_medical_profile.affiliated_hospitals">
                            {{hospital}}</li>
                    </ul>
                </tr>

            </ng-template>
        </p-table>
    </div>
</div>
<div class="row container justify-content-center text-center alert alert-danger"
    *ngIf="response.success!=null && response.success==false">
    <p *ngIf="response.error!=null">{{response.error.message}}</p>
    <div *ngIf="serverError?.error!=null && serverError?.statusCode!=500">
        <p *ngFor="let message of serverError?.message">{{message}}</p>
    </div>
    <div *ngIf="serverError?.error!=null && serverError?.statusCode==500">
        <p>{{serverError?.message}}</p>
    </div>

</div>
<h4 *ngIf="posting">Fetching Doctor Profile...</h4>
<p-progressSpinner [style]="{width: '50px', height: '50px'}" *ngIf="posting" strokeWidth="6"></p-progressSpinner>